interface IChatAccountProps {
  id: number;
  accountId: number;
  name: string;
  pubsubToken: string;
}

export class MChatAccount {
  props: IChatAccountProps;

  constructor(props: IChatAccountProps) {
    this.props = props;
  }
}
